export function isElementInViewport(
  el: HTMLElement,
  axios: "x" | "y" | "xy" = "y"
) {
  const rect = el.getBoundingClientRect();
  const isInX =
    rect.left >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  const isInY =
    rect.top >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight);
  if (axios === "y") {
    return isInY;
  }
  if (axios === "x") {
    return isInX;
  }
  return isInX && isInY;
}

export function isElementPartialInViewport(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <=
      (window.innerHeight ||
        document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.left <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /* or $(window).width() */
  );
}

export function elementInViewportRatio(el: HTMLElement): number {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  if (
    rect.bottom < 0 ||
    rect.right < 0 ||
    rect.top > windowHeight ||
    rect.left > windowWidth
  ) {
    return 0;
  }
  const height = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
  const width = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
  return (height * width) / (rect.height * rect.width);
}
